export default "__VITE_ASSET__CtRnH$ul__"